<template>
  <div class="market-price-detail-modal-table">
    <template>
      <table class="table amt-table" style="width:100%">
        <thead>
        <tr>
          <th class="col-1">구매일</th>
          <th class="col-1">결제일</th>
          <th class="col-1">구분</th>
          <th class="col-4">내용</th>
          <th class="col-1">플랜</th>
          <th class="col-3">서비스 이용기간</th>
          <th class="col-1">금액</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, item_idx) in list" :key="`item-${item_idx}`">
          <td>{{ item.created_time }}</td>
          <td>{{ item.next_date }}</td>
          <td>{{ item.app_type }}</td>
          <td>{{ item.product_name }}</td>
          <td>{{ item.plan }}</td>
          <td>{{ item.period }}</td>
          <td>{{ item.price | currency }}</td>
        </tr>
        </tbody>
      </table>

      <div class="flex-end" style="padding: 0 17px;">
        <div class="flex-between" style=";width:170px">
          <div class="main">소계</div>
          <div>{{ next_date_info.total_pay_price * 10 / 11 | currency }}</div>
        </div>
      </div>
      <div class="flex-end" style="padding: 0 17px;margin-top:8px">
        <div class="flex-between" style="width:170px">
          <div class="main">부가세(10%)</div>
          <div>{{ next_date_info.total_pay_price / 11 | currency }}</div>
        </div>
      </div>

      <div class="flex-between" style="padding: 0 17px;margin-top:12px">
        <div>
          <span style="margin-right:8px">결제 수단</span>
          <span>{{ service.credit_card }}</span>
        </div>

        <div class="flex-between" style="width: 170px;padding-bottom: 24px">
          <div style="font-weight:bold;color:#363636;">총합계</div>
          <div>{{ next_date_info.total_pay_price | currency }}</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  export default {
    props: {
      service: {
        type: Object
      },
      next_date_info: {
        type: Object
      }
    },
    name: "NextDatePriceDetailModal",
    created() {
      this.initList();
    },
    data() {
      return {
        list:[],
        date: '',
        product: undefined,
        selectorStocks: []
      }
    },
    computed: {

    },
    methods: {
      getPlanPrice(option_id) {
        let date_unit = this.service.service_order.date_unit
        let price = 0;
        let stock = find(this.selectorStocks, 'id', option_id);
        if(this.product) {
          this.product.selectors.forEach(item=>{
            let data = find(item.options, 'id', stock.options[0])
            if(data) {
              if(date_unit===1) {
                price = data.price
              } else {
                let item = find(data.subscriptions, 'date_unit', date_unit)
                price = item.price
              }
            }
          })
        }
        return price * date_unit
      },
      async getSelectorStocks() {
        let product_id = this.service.service_order.options[0].product;
        await this.$axios.get(`https://master-dev.launchpack.co.kr:1111/public/launchpack/v1/theme/${product_id}`).then(res=>{
          this.product = res.data;
        })
        let url = this.masterBackendUrl + `public/product/${product_id}/selector_stocks`
        await this.$axios.post(url).then(res => {
          this.selectorStocks = res.data.stocks;
        })
      },
      async initList() {
        await this.getSelectorStocks();
        if(this.next_date_info && this.next_date_info.next_date) {
          // 솔루션, 호스팅
          let sorder = this.service.service_order
          sorder.is_subscription = true
          if(sorder.next_date) {
            let remain = this.moment(this.next_date_info.next_date).diff(this.moment(sorder.next_date), 'days');
            if(remain===0) {
              let item = {
                created_time: this.datesFormat(sorder.created_time, 'date_3'),
                next_date: this.datesFormat(sorder.next_date, 'date_3'),
                app_type: '솔루션',
                product_name: sorder.options[0].name,
                plan: sorder.date_unit + '개월',
                period: this.periodOrder(sorder),
                price: this.getPlanPrice(sorder.options[0].id)
              }
              this.list.push(item);
              let item2 = this.cloneItem(item);
              item2['app_type'] = '호스팅'
              item2['product_name'] = sorder.hosting.name
              item2['price'] = sorder.hosting.price * sorder.date_unit
              this.list.push(item2);
            }
          }

          // 앱마켓
          if(this.service.service_app_order.length>0) {
            this.service.service_app_order.forEach(order => {
              let remain = this.moment(this.next_date_info.next_date).diff(this.moment(order.next_date), 'days')
              if(remain===0) {
                let item = {
                  created_time: this.datesFormat(order.created_time, 'date_3'),
                  next_date: this.datesFormat(order.next_date, 'date_3'),
                  app_type: order.app_type === 'package' ? '플랫폼 팩' : order.app_type === 'plugin' ? '플러그인' : '추가서비스',
                  product_name: order.product.name,
                  plan: this.planType(order),
                  period: this.periodOrder(order),
                  price: order.subscribe_price * 10 / 11
                }
                this.list.push(item);
              }
            })
          }
        }
      },
      planType(order) {
        if(order.app_type==='package') {
          return order.date_unit.toString() + '개월'
        } else {
          return order.is_subscription?'월결제':'건결제'
        }
      },
      periodOrder(order) {
        if(order.is_subscription) {
          return `${this.datesFormat(order.start_date, 'date_3')}~${this.datesFormat(order.end_date, 'date_3')}`
        } else {
          return `${this.datesFormat(order.start_date, 'date_3')}~`
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .market-price-detail-modal-table tbody tr:last-child
    border-bottom 1px solid #000000
</style>
